import { render, staticRenderFns } from "./CorporateStyle.vue?vue&type=template&id=595074d5&scoped=true"
import script from "./CorporateStyle.vue?vue&type=script&setup=true&lang=js"
export * from "./CorporateStyle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CorporateStyle.vue?vue&type=style&index=0&id=595074d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595074d5",
  null
  
)

export default component.exports